// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__32Z_E","info":"Note_info__OBraP","note":"Note_note__dUMWI","actions":"Note_actions__1AmPq"};